import { css as _css } from "@emotion/core";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import { ChevronDownIcon, TickIcon } from '@domain-group/fe-co-icon';
import WMSMapLayer from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer';
import { storageFactory } from '@domain-group/fe-helper';
import { SCHOOL_LAYER_DEFAULT, SCHOOL_LAYER_HIGH_SCHOOL, SCHOOL_LAYER_COLLEGE } from '../enums/advanced-option';
import MapType from '../enums/map-type';
import LandDetailsOnboarding from './land-details-onboarding';
import * as parentStyles from './tabbed-maps.style';
import * as styles from './land-details-dropdown.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SCHOOL_LABEL = 'ACT public school enrolment areas';
var ONBOARDING_STORAGE_KEY = 'land-details-onboarding-closed';
var LandDetailsDropDownItem = props => ___EmotionJSX("button", {
  css: styles.dropDownItem,
  type: "button",
  onClick: props.onClick
}, ___EmotionJSX("span", {
  css: styles.dropDownItemLabel
}, props.label), props.checked && ___EmotionJSX(TickIcon, {
  css: styles.dropDownItemCheckedIcon
}));
LandDetailsDropDownItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool
};
LandDetailsDropDownItem.defaultProps = {
  checked: false
};
class LandDetailsDropDown extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "closeDropDown", () => {
      this.setState({
        dropDownVisible: false
      });
    });
    _defineProperty(this, "openDropDown", () => {
      this.setState({
        dropDownVisible: true
      });
    });
    _defineProperty(this, "closeOnboardingPopup", () => {
      this.storage.setItem(ONBOARDING_STORAGE_KEY, true);
      this.setState({
        onboardingPopup: false
      });
    });
    this.storage = storageFactory({
      name: 'listing',
      driver: storageFactory.LOCALSTORAGE
    });
    this.state = {
      dropDownVisible: false,
      currentLayer: props.currentLayer,
      onboardingPopup: !this.storage.getItem(ONBOARDING_STORAGE_KEY)
    };
    this.closeDropDown = this.closeDropDown.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentLayer !== prevState.currentLayer) {
      return {
        currentLayer: nextProps.currentLayer
      };
    }
    return null;
  }
  render() {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("button", {
      type: "button",
      css: /*#__PURE__*/_css([parentStyles.tab(this.props.selected), ...(this.state.dropDownVisible ? [styles.tabPressed] : [])]),
      onClick: () => {
        this.closeOnboardingPopup();
        this.openDropDown();
      }
    }, ___EmotionJSX("span", {
      css: styles.tabLabel
    }, MapType.LAND_DETAILS.label), ___EmotionJSX(ChevronDownIcon, {
      css: styles.tabIcon,
      size: "custom"
    })), this.state.dropDownVisible && ___EmotionJSX("div", {
      css: styles.dropDown
    }, ___EmotionJSX(OutsideClickHandler, {
      onOutsideClick: this.closeDropDown
    }, ___EmotionJSX(LandDetailsDropDownItem, {
      checked: !this.state.currentLayer && this.props.enableCheck,
      label: "No overlays",
      onClick: () => {
        this.props.onSelect(null);
        this.closeDropDown();
        this.setState({
          currentLayer: null
        });
      }
    }), this.props.supportedOverlays.map(layerKey => ___EmotionJSX(LandDetailsDropDownItem, {
      checked: layerKey === this.state.currentLayer && this.props.enableCheck,
      label: WMSMapLayer[layerKey].label,
      key: layerKey,
      onClick: () => {
        this.props.onSelect(layerKey);
        this.closeDropDown();
        this.setState({
          currentLayer: layerKey
        });
      }
    })), ___EmotionJSX(LandDetailsDropDownItem, {
      checked: (this.state.currentLayer === SCHOOL_LAYER_DEFAULT || this.state.currentLayer === SCHOOL_LAYER_HIGH_SCHOOL || this.state.currentLayer === SCHOOL_LAYER_COLLEGE) && this.props.enableCheck,
      label: SCHOOL_LABEL,
      key: SCHOOL_LAYER_DEFAULT,
      onClick: () => {
        this.props.onSelect(SCHOOL_LAYER_DEFAULT, true);
        this.closeDropDown();
        this.setState({
          currentLayer: SCHOOL_LAYER_DEFAULT
        });
      }
    }))), this.state.onboardingPopup && ___EmotionJSX(LandDetailsOnboarding, {
      onClose: this.closeOnboardingPopup,
      onTryOut: () => {
        this.openDropDown();
        this.closeOnboardingPopup();
      }
    }));
  }
}
LandDetailsDropDown.propTypes = {
  supportedOverlays: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  currentLayer: PropTypes.string,
  selected: PropTypes.bool,
  enableCheck: PropTypes.bool
};
LandDetailsDropDown.defaultProps = {
  supportedOverlays: ['TP_ZONES', 'EASEMENTS', 'UNIMPROVED_LAND_VALUES', 'CONTOURS'],
  onSelect: () => {},
  currentLayer: null,
  selected: null,
  enableCheck: true
};
export default LandDetailsDropDown;